import { Component } from '@angular/core';

@Component({
    selector: 'app-vendors',
    templateUrl: './vendors.component.html',
    styleUrls: ['./vendors.component.scss'],
    standalone: false
})
export class VendorsComponent {

}
